import { SearchInput } from '../shared';
import { SortOrder, CountrySortType } from '../enums';

export class GetCountriesInput extends SearchInput<CountrySortType> {
    constructor() {
        super(CountrySortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}